import Api from '../http.service';

export const getMe = () => Api.GET({ url: 'user_profile/me' });

export const getEmployeeByMe = () =>
  Api.GET({ url: 'user_profile/employee_by_me' });
/**
 * @param {Object} payload
 * @param {string} payload.profileId
 */
export const getUsersByBusiness = (payload) =>
  Api.GET({ url: `user_profile/users_by_business/${payload.profileId}` });
